import type { IUser } from '@tambola/shared';
import { useRoomStore } from '../../store/room.store.js';

interface PlayerListCardProps {
  currentUser: IUser | null;
}

export function PlayerListCard({ currentUser }: PlayerListCardProps) {
  const { players } = useRoomStore();

  return (
    <div className="glass rounded-3xl p-5 border border-white/10 shadow-glow-lg flex flex-col h-full text-left overflow-hidden">
      <h3 className="font-display text-base font-black tracking-wider text-amber-300 uppercase mb-4">
        Players Joined
      </h3>

      <div className="flex-1 overflow-y-auto pr-1 space-y-2 max-h-[300px]">
        {players.map((player) => {
          const isMe = currentUser && player.displayName === currentUser.displayName;
          const isHost = player.isHost;

          return (
            <div
              key={player.id}
              className={`p-3 rounded-2xl border flex items-center justify-between transition-all duration-300 ${
                isMe
                  ? 'bg-purple-600/10 border-purple-500/30 shadow-inner'
                  : 'bg-slate-950/20 border-white/5'
              }`}
            >
              {/* Profile image & Name */}
              <div className="flex items-center space-x-3">
                <div className="w-8 h-8 rounded-full bg-gradient-to-tr from-purple-600 to-pink-500 flex items-center justify-center text-xs font-black shadow-glow text-white">
                  {player.displayName.charAt(0).toUpperCase()}
                </div>
                <div className="flex items-center space-x-1.5">
                  <span
                    className={`text-xs font-bold tracking-wide ${
                      isMe ? 'text-purple-300' : 'text-white'
                    }`}
                  >
                    {player.displayName}
                  </span>
                  {isMe && (
                    <span className="text-[8px] font-black uppercase bg-purple-500/20 text-purple-400 px-1.5 py-0.5 rounded border border-purple-500/20">
                      You
                    </span>
                  )}
                  {isHost && (
                    <span
                      title="Room Host"
                      className="text-xs filter drop-shadow-[0_0_2px_rgba(245,158,11,0.5)]"
                    >
                      👑
                    </span>
                  )}
                </div>
              </div>

              {/* Ready status badge */}
              <div className="flex items-center space-x-1.5">
                <span
                  className={`w-2 h-2 rounded-full ${
                    player.isReady ? 'bg-emerald-500 animate-pulse' : 'bg-amber-500 animate-pulse'
                  }`}
                />
                <span
                  className={`text-[9px] font-black uppercase tracking-wider font-mono ${
                    player.isReady ? 'text-emerald-400' : 'text-amber-400'
                  }`}
                >
                  {player.isReady ? 'Ready' : 'Waiting'}
                </span>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
